import { replace } from 'ramda'
import piexif from 'piexifjs'

const convertImage = async file => new Promise((resolve, reject) => {
    const uploadFile =  {
        contentType: file.type,
        fileName: replace(/\s/g, '', file.name),
    }
    const reader = new FileReader()
    reader.addEventListener('load', () => {
        // BEWARE: this is a temporary fix! the API expects a string that doesn't contain `data:[<mediatype>][;base64],`
        // We want to eventually pass in a blob (an acceptedFile) in the data field, and have the API use that to create
        // a Zendesk url that gets passed back in the response
        // remove exif metadata so customers aren't giving location etc.
        const removedExifFile = file.type === 'image/jpeg' ? piexif.remove(reader.result) : reader.result
        uploadFile.data = replace(/[^,]+,/, '', removedExifFile)
        resolve(uploadFile)
    })
    reader.readAsDataURL(file)
    return uploadFile
})

export { convertImage }
